/**
 * Resolves the tax percent of the fixed platform-usage fee (MID-747) that the
 * "IVA {percent}% ..." label interpolates. The tenant config (`fixedFee.taxPercent`,
 * the same value the backend uses to compute the amounts) is the source of truth;
 * when it is missing the percent is derived from the amounts the API already sent,
 * so the label can never state a percent that contradicts the money on screen.
 * @param {Object} [fee] - Fee amounts as sent by the API.
 * @param {number} [fee.amount] - Fee charged, per seat on search or as a purchase total.
 * @param {number} [fee.tax] - Tax over that amount, in the same scale.
 * @param {number|string} [configuredPercent] - Percent from the tenant config (`env.fixedFee.taxPercent`).
 * @returns {number|null} Percent to interpolate, or null when it cannot be resolved.
 */
const getFixedFeeTaxPercent = (fee, configuredPercent) => {
  const percent = Number(configuredPercent);
  if (percent > 0) return percent;

  const amount = Number(fee?.amount);
  const tax = Number(fee?.tax);
  if (amount > 0 && tax > 0) return Math.round((tax / amount) * 100);

  return null;
};

export default getFixedFeeTaxPercent;
